<script>
  export default {
    props: {
      image: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        dialogVisible: false
      }
    },
    methods: {
      showBigImg() {

      }
    }
  }
</script>
<template>
  <section :class="$style.sectionOrganization">
    <div class="section ">
      <BaseSectionTitle title="組織架構" class="text-center"/>
      <div class="sectionOrganization__Box">
        <div class="text-center">
          <img :src="image" alt="">
        </div>
      </div>
      <BaseButton
        v-if="!!image" 
        class="isStylePrimary isSmall isFull isRadius mt-4 mb-5 d-md-none"
        @click="dialogVisible = !dialogVisible"
      >
        <i class="fal fa-search-plus"></i> 查看大圖
      </BaseButton>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="1200px"
      class="isStyleBigImg"
    >
      <img :src="image" alt="">
    </el-dialog>
  </section>
</template>
<style lang="scss" module>
  .sectionOrganization {
    width: 100%;
    max-width: 1810px;
    padding-right: 20px;
    padding-left: 20px;
    margin: 0 auto;

    :global {
      .sectionOrganization {
        &__Box {
          position: relative;
          // box-shadow: 0 0 30px rgba(141, 141, 141, 0.15);
          // height: 890px;
          &::before {
            content: '';

          }
        }
      }
      .isStyleBigImg {
        .el-dialog {
          max-width: inherit;
          overflow: auto;
        }
      }
      
    }
  }

</style>
